import { useParams } from '@tanstack/react-router';
import {
  InterviewBriefDetailContainer,
  InterviewAttemptsContainer,
  SessionTurn,
} from '../../contexts/interviews';

export function InterviewDetailPage() {
  const { interviewId } = useParams({ from: '/authenticated/orgs/$orgSlug/sessions/$interviewId' });

  return (
    <InterviewBriefDetailContainer
      inviteId={interviewId}
      renderAttempts={(inviteId) => (
        <InterviewAttemptsContainer
          inviteId={inviteId}
          renderTurn={(turn, callStartedAt) => (
            <SessionTurn turn={turn} sessionStartedAt={callStartedAt} />
          )}
        />
      )}
    />
  );
}
